import { TApi } from './types';
import { auth } from './auth';
import { shops } from './shops';
import { user } from './user';
import { hscodes } from './hscodes';
import { goods } from './goods';
import { classifications } from './classifications';

const api: TApi = {
	auth,
	shops,
	user,
	hscodes,
	goods,
	classifications,
};

export { api };
